import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import { Search, X } from "lucide-react";
import { useDataTable } from "@/components/custom/table/data-table";
import { DataTableViewOptions } from "@/components/custom/table/data-table-view-options";

export function ProjectInvitationsToolbar() {
  const table = useDataTable();
  const isFiltered = table.getState().columnFilters.length > 0;

  return (
    <div className="flex flex-col items-start justify-between gap-2 lg:flex-row lg:items-center">
      <div className="flex w-full flex-col items-start gap-2 lg:flex-1 lg:flex-row lg:items-center">
        <div className="relative w-full max-w-[250px] lg:w-[200px] xl:w-[250px]">
          <Search className="absolute top-2 left-2 h-4 w-4 text-muted-foreground" />
          <Input
            className="h-8 pl-8 text-sm"
            onChange={(event) =>
              table
                .getColumn("invitee_email")
                ?.setFilterValue(event.target.value)
            }
            placeholder="Search by email..."
            value={
              // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
              (table.getColumn("invitee_email")?.getFilterValue() as string) ??
              ""
            }
          />
        </div>
        {!!isFiltered && (
          <Button
            className="h-8 px-2 lg:px-3"
            onClick={() => table.resetColumnFilters()}
            variant="warning"
          >
            Reset
            <X className="ml-1 size-4" />
          </Button>
        )}
      </div>
      <DataTableViewOptions table={table} />
    </div>
  );
}
